import React from 'react';
  import axios2 from 'services/axios2';
  import moment from "moment";

  import {useParams, Link,hashHistory} from 'react-router-dom';
  import { ToastContainer, toast } from 'react-toastify';
  import NuDropdown from 'components/nubox/NuDropdown';
  import ImageUploadSingle from 'components/nubox/ImageUploadSingle';

  //import listac from '../assets/img/lista2.png';
  import {
    Table,
    Button,
    Container,
    Modal,
    ModalHeader,
    ModalBody,
    FormGroup,
    ModalFooter,
    ToastHeader,
  } from 'reactstrap';

  const formInitial = {
    idd:0,
    ope:'n',

    id_asisfe:0,
    
    
    id_peri:0,
    id_mate:0,
    fecha:'',
    detalle:'',
  };
  //$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
  class ModalAsistencia extends React.Component {
    state = {
      modalInsertar:false,
      form: formInitial,
      
      grupos:[], /* combo grupos */
    };
    //------------------------------------------------------
    componentDidMount() {
      console.log('componentDidMount Modal');
      //--limpiamos el array de prueba
      
      
      //this.cargar_grupos();
      //const date = moment();
      //const formattedDate = date.format('YYYY-MM-DD');
      
      //console.log(formattedDate);
      //---------
      this.limpiar();
    }
    //-------------------
    limpiar = () =>{
      const date = moment();
      const dateNow = date.format('YYYY-MM-DD');

      formInitial.fecha = dateNow
      this.setState({form: formInitial });
    }
    //----------------especial, actualiza valores del form -------------------------------
    handleChangeForm = (e) => {
      //requerimos la prop name='?' en cada control
      this.setState({
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      });
    };
    //----cargamos combo
    /*cargar_grupos = async() => {
      let param = { }
      await axios2.post('cbo_grupos', param).then(res => {
          if(res.data.length>0){ 
              this.setState({grupos: res.data});
          }else{
            toast.error('No existen datos');
          }
      }).catch(error => {
          alert('---- Existio un error ---');
          console.log(error);
      });
    };*/
    //======================================================
    showModal = () => {
      //setModalOpen(true);
      this.setState({ modalInsertar: true});
    }
    closeModal = () => {
      //setModalOpen(true);
      this.setState({ modalInsertar: false});
    }
    //---------------
    nuevo =(id_mate, id_peri) =>{
      console.log('nuevo');
      //this.limpiar();
      //let materia = this.props.store.materia
      //let user = this.props.store.user
      formInitial.id_mate = id_mate
      formInitial.id_peri = id_peri
      //----------------------------------------

      this.setState({
        form: {
          ...formInitial,
          idd: 0,
          ope:'n'
        },
        modalInsertar: true,
      });
      

    }
    //---------------
    editar =(idd)=>{
      console.log('editar');
      let param = { idd: idd, ope:'f'  }
      
      axios2.post( 'asistencia2_fecha_store' , param).then(res => {
        console.log(res.data);

          if(res.data !== null){               
              //---asignamos los valores
              this.setState({
                form: {
                  ...res.data,
                  'idd': idd,
                  'ope': 'e',
                },
                modalInsertar: true, /* show modal */
              });

              //----
          }else{
            toast.error('No existen datos');
          }

      }).catch(error => {
          alert('---- Existio un error ---');
          console.log(error);
          
      });
    }
    //----------------------------
    eliminar =(idd)=>{
      console.log('eliminar');
      let param = { 
        idd: idd,
        ope:'x'
      }
      //console.log(param);
      axios2.post( 'asistencia2_fecha_store', param).then(res => {
        console.log(res.data);
  
          if(res.data.exito===1){ 
              this.limpiar();
              this.closeModal();
              toast.success('Eliminado con exito');
              this.props.okModal(); //callback
          }else{
            toast.error('Error al eliminar registro', {
              position: toast.POSITION.TOP_RIGHT
            });
          }
  
      }).catch(error => {
          alert('---- Existio un error ---');
          console.log(error);
          
      });
    }
    //----------------------------
    validar = () =>{
      if( this.state.form.id_espe===0){
        toast.error( 'Especialidad no valido', {position: toast.POSITION.TOP_RIGHT});
        return true;
      }
    }
    /************************************************ */
    okImage = (filename) =>{    
      this.setState({ form:{...this.state.form, foto_path1: filename}}); 
    }
    cancelImage = () =>{
      //---ocultamos la ventana
      this.setState({ form:{...this.state.form, foto_path1: '' }}); 
    }
    //----------------------------
    formSave = () => {
      /*let error = this.validar();
      if(error===true){
        return;
      }*/
      
      let param = this.state.form;
      //console.log(param);
  
      axios2.post('asistencia2_fecha_store', param).then(res => {
          let response = res.data;
        
          if(response.exito===1){ 
              
            toast.success( response.mensaje, {position: toast.POSITION.TOP_RIGHT});
            //---llamamos a la funcion externa
            this.props.okModal();
            this.closeModal();
          }else{
  
            toast.error( response.mensaje, {position: toast.POSITION.TOP_RIGHT});
          }
  
      }).catch(error => {
          alert('Bad Request');
          console.log(error);
          
      });
  
    }
    //---------------------------
    render() {
    
      return (
        <div>
          <ToastContainer />
          
          {/*--- modal---- */}
          <Modal isOpen={this.state.modalInsertar} toggle={this.closeModal} >
            <ModalHeader toggle={this.closeModal} 
              className= { (this.state.form.ope==='n'? 'header-verde':'header-naranja') + ' ' + (this.state.form.ope==='n'? "color:'#45b545'":"color:'#343b43'")  } 
            >
              <span className="modal-title">
              { this.state.form.ope==='n'
                ? "Nuevo"
                : "Editar"
              }
              </span>
              {
                //JSON.stringify( this.state.form )
              }
            </ModalHeader>
  
            <ModalBody style={{background: "#F7F7F7"}}>
                                
              <form  method='POST'>
        
            
                <div className='form-group row'>
                    <label for='id_carre' className='col-lg-3 control-label'><b>Cod. </b></label>
                    <div className='col-lg-9'>
                        
                    <input
                      type='text'
                      name='id_asisfe'
                      value={this.state.form.id_asisfe}
                      onChange={this.handleChangeForm}
                      className='form-control'
                      disabled={true}
                    />
      
                    </div>
                </div>
                <div className='form-group row pt-2'>
                    <label for='nombreca' className='col-lg-3 control-label'><b>Fecha</b></label>
                    <div className='col-lg-9'>
                        
                    <input
                      type='date'
                      name='fecha'
                      value={this.state.form.fecha}
                      onChange={this.handleChangeForm}
                      className='form-control'
                    />
      
                    </div>
                </div>
                <div className='form-group row pt-2'>
                    <label className='col-lg-3 control-label'><b>Detalle</b></label>
                    <div className='col-lg-9'>
                        
                    <input
                      type='text'
                      name='detalle'
                      value={this.state.form.detalle}
                      onChange={this.handleChangeForm}
                      className='form-control'
                    />
      
                    </div>
                </div>

                {/* 
                <div className='form-group row'>
                    <label for='fotoca' className='col-lg-3 control-label'><b>fotoca</b></label>
                    <div className='col-lg-9'>
                         
                      <ImageUploadSingle  
                        okImage={ this.okImage}
                        cancelImage={ this.cancelImage}
                        imageURL={process.env.REACT_APP_AFILES}
                        fileName={this.state.form.fotoca}
                      />
        
                    </div>
                </div>
               */}
                
              </form>
        
              
            </ModalBody>
            <ModalFooter>
              <Button color='primary' onClick={ this.formSave}>Guardar</Button>{' '}
              <Button color='secondary' onClick={this.closeModal}>Cancel</Button>
            </ModalFooter>
          </Modal>
        </div>
      );
    }
  }
  
  //------------
  export default ModalAsistencia;